angular.module('core')
    .directive('notZeroValidator', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                ctrl.$validators.zero = (modelValue) => {
                    if (ctrl.$isEmpty(modelValue)) {
                        return true;
                    }
                    let num = parseFloat(modelValue);
                    return angular.isNumber(num) && num !== 0
                }
            }
        };
    })
